import PropTypes from 'prop-types';
import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import withGS from '../../core/withGShoc';
import CollectionConceptSlat from './CollectionConceptSlat';

const loadOptions = {
    predicates: [
        "http://www.w3.org/2004/02/skos/core#inScheme",
        "http://www.w3.org/2004/02/skos/core#prefLabel",
        "http://www.w3.org/2002/07/owl#deprecated",
        "http://www.w3.org/2008/05/skos-xl#prefLabel",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
    ],
    tests: [
        {
            id: "http://www.w3.org/2008/05/skos-xl#prefLabel",
            join: [{
                predicate: "http://www.w3.org/2008/05/skos-xl#literalForm"
            }]
        }
    ]
};

const Types = {
    COLLECTIONCONCEPT: 'collectionconcept'
};

const conceptSource = {
    beginDrag(props) {
        return {
            conceptId: props.id
        };
    }
};

const conceptTarget = {
    drop(props, monitor) {
        const item = monitor.getItem();
        // Tell parent component we want to move
        props.onMove(item.conceptId, props.id);
    }
};

function collectSource(connect) {
    return {
        connectDragSource: connect.dragSource()
    };
}

function collectTarget(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    };
}

class CollectionConcept extends React.Component {

    render() {

        const { position, data, lang, onSelect, onBreakLink, viewLang, activeConcept,
            isOver, connectDragSource, connectDropTarget, isReadOnly, ordered } = this.props;

        if (data.pendingDeletion) return null;

        return (
            isReadOnly || !ordered ?
                <div>
                    <CollectionConceptSlat
                        defaultLang={lang}
                        lang={lang}
                        position={position}
                        activeConcept={activeConcept}
                        viewLang={viewLang}
                        data={data}
                        onSelect={onSelect}
                        onBreakLink={onBreakLink} />
                </div>
                :
                connectDropTarget(connectDragSource(
                    <div>
                        <CollectionConceptSlat
                            defaultLang={lang}
                            viewLang={viewLang}
                            isOver={isOver}
                            activeConcept={activeConcept}
                            position={position}
                            data={data}
                            onSelect={onSelect}
                            onBreakLink={onBreakLink} />
                    </div>
                ))
        );
    }
}

CollectionConcept.propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    ordered: PropTypes.bool.isRequired,
    activeConcept: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isOver: PropTypes.bool.isRequired,
    position: PropTypes.number.isRequired
};

const cpt = DropTarget(Types.COLLECTIONCONCEPT, conceptTarget,
    collectTarget)(DragSource(Types.COLLECTIONCONCEPT, conceptSource,
        collectSource)(CollectionConcept));

export default withGS(cpt, ["ALL"], null, loadOptions, true);